document.addEventListener('DOMContentLoaded', function () {

  const wrappers = document.querySelectorAll('.fw-faq-wrapper');

  wrappers.forEach((wrapper) => {

    const allowMultiple =
      wrapper.dataset.multiOpen === 'true';

    const items =
      wrapper.querySelectorAll('.fw-faq-item');

    items.forEach((item) => {

      item.addEventListener('toggle', function () {

        if (!allowMultiple && item.open) {

          items.forEach((otherItem) => {

            if (otherItem !== item) {
              otherItem.removeAttribute('open');
            }

          });

        }

      });

    });

  });

});